module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Joe Reel-b870d68734a2d65cd7225088b3aff6a9.png";